import assetPath from '/app/packages/lebenslauf/articles/src/assets/lebenslauf-schueler.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')